import React, { useState, useEffect } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import axios from "axios";
import Fuse from "fuse.js"; // Import Fuse.js
import { endPoints } from "../../Constants";
import { useTranslation,Trans  } from 'react-i18next';
const Faq = () => {

    const [activeKey, setActiveKey] = useState("0");
    const [myFaq, setFaq] = useState([]);
    const [filteredFaq, setFilteredFaq] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const { t,i18n  } = useTranslation();
    // Function to handle accordion item click
    const handleAccordionClick = (eventKey) => {
        setActiveKey(activeKey === eventKey ? null : eventKey);
    };

    // Fetch FAQs on component mount
    useEffect(() => {
        const token = localStorage.getItem('token');
        axios.get(`${endPoints.faq}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
            .then((res) => {
                setFaq(res.data);
                setFilteredFaq(res.data); // Initialize filtered FAQs with all data
            })
            .catch((err) => {
                console.error("Error fetching data:", err);
            });
    }, []);

    // Handle search functionality
    const handleSearch = (event) => {
        const value = event.target.value;
        setSearchTerm(value);

        if (value.trim()) {
            const fuse = new Fuse(myFaq, {
                keys: ['faQ_QUESTION', 'faQ_ANSWER'], // Specify searchable fields
                threshold: 0.3, // Lower threshold = stricter match
            });

            const searchResults = fuse.search(value).map((result) => result.item);
            setFilteredFaq(searchResults);
        } else {
            setFilteredFaq(myFaq); // Reset to full data if search is cleared
        }
    };

    return (
        <>
            <section className="lyt-section typ-faq-sec custom-margin-top">
                <div className="container">
                    <div className='bs-breadcrumb'>
                        <Breadcrumb>
                            <Breadcrumb.Item href="/">{t('home')}</Breadcrumb.Item>
                            <Breadcrumb.Item active>{t('faq')}</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                    <div className="heading-wrapper">
                        <div>
                            <h2 className="bs-heading typdblue mb-2" data-aos="fade-in" data-aos-delay="200">{t('faq')}</h2>
                            <p className="bs-para typblue" data-aos="fade-in" data-aos-delay="300">{t('faqDesc')}</p>
                        </div>
                    </div>

                    <div className="serach-bar" data-aos="fade-in" data-aos-delay="300">
                        <input
                            type="text"
                            placeholder={t('searchBy')}
                            value={searchTerm}
                            onChange={handleSearch}
                        />
                    </div>

                    {filteredFaq.length > 0 ? (
                        <Accordion
                            activeKey={activeKey} 
                            onSelect={handleAccordionClick}
                            className='bs-accordion'
                            data-aos="fade-in" data-aos-delay="200"
                        >
                            {filteredFaq.map((item, index) => {
                                const { faQ_QUESTION, faQ_ANSWER,faQ_QUESTION_Mr,faQ_ANSWER_Mr } = item;
                                // Pick question & answer based on language
                                const question = i18n.language === 'mr' ? faQ_QUESTION_Mr : faQ_QUESTION;
                                const answer = i18n.language === 'mr' ? faQ_ANSWER_Mr : faQ_ANSWER;
                                return (
                                    <Accordion.Item
                                        eventKey={index.toString()}
                                        key={index}
                                        className={activeKey === index.toString() ? 'active' : ''}
                                    >
                                        <Accordion.Header>{question}</Accordion.Header>
                                        <Accordion.Body>
                                            <div className='question-wrapper'>
                                                {answer}
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                );
                            })}
                        </Accordion>
                    ) : (
                        <div className="no-data-message" data-aos="fade-in" data-aos-delay="200">
                            <p>{t('searchNotFound')}</p>
                        </div>
                    )}
                </div>
            </section>
        </>
    );
};

export default Faq;
